/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MessageRepresentationFromJSON, MessageRepresentationToJSON, } from './';
export function MessageThreadMetadataRepresentationFromJSON(json) {
    return MessageThreadMetadataRepresentationFromJSONTyped(json, false);
}
export function MessageThreadMetadataRepresentationFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        totalMessageCount: json['totalMessageCount'],
        cursors: json['cursors'],
        initialMessage: MessageRepresentationFromJSON(json['initialMessage']),
        lastMessage: MessageRepresentationFromJSON(json['lastMessage']),
    };
}
export function MessageThreadMetadataRepresentationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        totalMessageCount: value.totalMessageCount,
        cursors: value.cursors,
        initialMessage: MessageRepresentationToJSON(value.initialMessage),
        lastMessage: MessageRepresentationToJSON(value.lastMessage),
    };
}
